<template>
  <div class="container">
    <h1>
      this is the worst idea, that oficially lost to "duh, yknow, AIRBNB but for
      cars", "covid test in your car" joke and "lets make an AR app with cars"
      (which we already had)
    </h1>
  </div>
</template>
<script>
export default {};
</script>